import {
	TypicalResponse,
	AccountMinimumData,
	AccountMinimumDataDic,
} from './models.def';
import fb from './gobi-mw-firestore';
import store from '@/store';
import userx from './modules/userx';
import firebase from 'firebase';

const db: firebase.firestore.Firestore = fb.db;
const functions: firebase.functions.Functions = fb.functions;

export class Userz {


	public currentAccountId: string | null = null;

	private _unsubscribeListenToMyAccounts: (() => void) | null = null;

	constructor() {

		// auto init when user.supportLvl >= 1
		if (userx && userx.supportLvl && userx.supportLvl >= 1) {
			this.init();
		}
		store.watch(
			(states, getters) => getters['userx/supportLvl'],
			(newValue, oldValue) => {
				if (!newValue) {
					if (this._unsubscribeListenToMyAccounts) {
						this._unsubscribeListenToMyAccounts();
						this._unsubscribeListenToMyAccounts = null;
					}
					userx.updateMyAccounts({});
				} else if (newValue >= 1) {
					this.init();
				}
			});
	}


	public async init() {
		if (!this._unsubscribeListenToMyAccounts) {
			this.listenToMyAccountsSnapshop();
		}
	}
	public listenToMyAccountsSnapshop() {
		this._unsubscribeListenToMyAccounts = db.doc(`emails/${userx.user!.email}`)
			.onSnapshot((doc) => {
				if (!doc.exists) {
					userx.updateMyAccounts({});
					return;
				}
				const accountsDic = doc.data()!.accounts as AccountMinimumDataDic;

				userx.updateMyAccounts(accountsDic);
			});
	}
	public async addMyAccount(accountData: AccountMinimumData) {
		const update: any = { accounts: {} };
		update.accounts[accountData.accountId] = accountData;
		try {
			await db.doc(`emails/${userx.user!.email}`).set(update, { merge: true });
			return { success: true } as TypicalResponse;
		} catch (error: any) {
			console.error(error);
			return { success: false, error, errorCode: error.detail || error.code, errorMessage: error.message };
		}

	}
	public async removeMyAccount(accountId: string) {
		const myAccounts = { ...userx.myAccountsDic };
		delete myAccounts[accountId];
		const update: any = { accounts: myAccounts };
		try {
			await db.doc(`emails/${userx.user!.email}`).update(update);
			return { success: true } as TypicalResponse;
		} catch (error: any) {
			console.error(error);
			return { success: false, error, errorCode: error.detail || error.code, errorMessage: error.message };
		}
	}
}
const userz = new Userz();
export default userz;
